'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

var _keys2 = require('lodash/keys');

var _keys3 = _interopRequireDefault(_keys2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

exports.default = focus;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function focus(series, focusSelections) {
  var serie = (0, _head3.default)(series);
  var datapoints = (0, _get3.default)(serie, 'datapoints', []);

  var _datapoints = (0, _map3.default)(datapoints, function (datapoint) {
    var _datapoint = (0, _omit3.default)(datapoint, (0, _map3.default)((0, _keys3.default)(focusSelections), function (focusKey) {
      return focusKey + 'Index';
    }));

    (0, _each3.default)(focusSelections, function (focusSelection, focusKey) {
      var _focusKey = focusKey + 'Index';

      (0, _each3.default)((0, _isArray3.default)(focusSelection) ? focusSelection : [focusSelection], function (focus, index) {
        if ((0, _get3.default)(focus, 'value') === _datapoint.key) _datapoint[_focusKey] = index;
      });
    });

    return _datapoint;
  });

  return [(0, _extends3.default)({}, serie, { datapoints: _datapoints })];
}